import React from 'react';

const Checkbox = ({ 
  id, 
  name, 
  label, 
  checked, 
  onChange, 
  disabled = false,
  ...props 
}) => {
  return (
    <div className="checkbox-group">
      <input
        type="checkbox"
        id={id || name}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox-input"
        {...props}
      />
      {label && (
        <label htmlFor={id || name} className="checkbox-label">
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
